import { FC } from 'react';
import styled from 'styled-components';
import { useSendingPlatformsQueryContext } from 'modules/sendingPlatforms/contexts';
import { Skeleton } from 'ui/skeleton';
import { Body2, spacing, smallShadow, H4 } from 'ui/theme';
import { SENDING_PLATFORMS_PAGE_TEXT as TEXT, CUSTOM_EMAIL } from '../../constants';
import { PlatformDescriptionCard } from './PlatformDescriptionCard';
import { EmptyStateCard } from './styled';
import { OrDivider } from './OrDivider';

export const Container = styled.div`
  margin-top: ${spacing.x3};
`;

const Heading = styled(H4)`
  margin-bottom: ${spacing.base};
`;

const ListContainer = styled.div`
  overflow: hidden;
  border-radius: ${spacing.half};
  ${smallShadow}
`;

export const UnconnectedPlatformsSection: FC = () => {
  const { unconnectedPlatforms, isLoadingEssentialData } = useSendingPlatformsQueryContext();

  const unconnectedPlatformsWithoutCustom = unconnectedPlatforms.filter(
    (sendingPlatform) => sendingPlatform !== CUSTOM_EMAIL,
  );

  const customPlatform = unconnectedPlatforms.find(
    (sendingPlatform) => sendingPlatform === CUSTOM_EMAIL,
  );

  return (
    <Container data-test="unconnected-platforms-section">
      <Heading>{TEXT.UNCONNECTED_HEADER}</Heading>
      {isLoadingEssentialData ? (
        <Skeleton height={112} />
      ) : (
        <>
          {unconnectedPlatforms.length === 0 && (
            <EmptyStateCard as="div">
              <Body2>{TEXT.UNCONNECTED_EMPTY_STATE}</Body2>
            </EmptyStateCard>
          )}
          <ListContainer>
            {unconnectedPlatformsWithoutCustom.map((id) => (
              <PlatformDescriptionCard key={id} sendingPlatform={id} />
            ))}
          </ListContainer>
          {customPlatform && (
            <>
              <OrDivider />
              <ListContainer>
                <PlatformDescriptionCard sendingPlatform={CUSTOM_EMAIL} />
              </ListContainer>
            </>
          )}
        </>
      )}
    </Container>
  );
};
